import { formatedDateTimeOffsetUtc, extractUtcOffset } from '@/lib/date-time-utils';
import { IEventV2 } from '@/app/dashboard/models/Event';

interface FormattedDateTimeProps {
  event: IEventV2;
  format: string;
}

const FormattedDateTime = ({ event, format }) => {
  if (!event?.startTimeStamp || !event?.location?.timeZone || !format) {
    return null;
  }

  const formattedDate = formatedDateTimeOffsetUtc(event.startTimeStamp, extractUtcOffset(event.location.timeZone), format);

  return <>{formattedDate}</>;
};

export default FormattedDateTime;
